import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Settings, SquareStack, Upload, Eye, EyeOff, X, Plus, Trash2, Edit2, Check, X as XIcon, Edit } from 'lucide-react'
import '../../assets/css/BiolLinkPage.css'
import { useDispatch, useSelector } from 'react-redux';
import BiolinkPreview from './BiolinkPreview'
import ButtonLoader from '../../components/loader/ButtonLoader'
import { bioLinkDetails } from '../../redux/slice/BioLinkPageDetails';
import { useNavigate, useBlocker } from 'react-router-dom';
import { updateBioLink } from '../../redux/slice/UpdateBioLinkPage';
import { toast } from 'react-toastify';
import Loader from '../../components/loader/Loader';
import Swal from 'sweetalert2';
import { checkVideoURL } from '../../redux/slice/CheckVideoURL';
import UpdateProfile from '../user-managemnet/UpdateProfile';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import BiolinkSubscription from './BiolinkSubscription';
import bioLinkImage from '../../../src/assets/images/biolink_dummy_img.png'
import { checkSocialLinkURL } from '../../redux/slice/CheckSoicalLinkUrl';
import thumbImage from '../../../src/assets/images/hand3.png'
import moment from 'moment';

export default function BiolLinkPage() {
    const [bool, setBool] = useState(false)
    const [show, setShow] = useState(false)
    const [show2, setShow2] = useState(false)
    const [activeTab, setActiveTab] = useState('settings')
    const [backgroundType, setBackgroundType] = useState('solid')
    const [selectedBackground, setSelectedBackground] = useState('#ffffff')
    const [selectedFontFamily, setSelectedFontFamily] = useState('Arial, sans-serif')
    const [selectedFontColor, setSelectedFontColor] = useState('#000000')
    // Custom gradient state
    const [gradientColor1, setGradientColor1] = useState('#ffffff')
    const [gradientColor2, setGradientColor2] = useState('#000000')
    const [gradientDirection, setGradientDirection] = useState('180deg')
    const [gradientType, setGradientType] = useState('linear')
    const [profilePhoto, setProfilePhoto] = useState(null)
    const [profilePhoto2, setProfilePhoto2] = useState(null)
    const [title, setTitle] = useState('')
    const [spinner, setSpinner] = useState(false)
    const [paragraph, setParagraph] = useState('')
    const [showTitle, setShowTitle] = useState(true)
    const [showParagraph, setShowParagraph] = useState(true)
    const [showBanner, setShowBanner] = useState(false)
    const [showProfilePhoto, setShowProfilePhoto] = useState(false)
    const [bannerImage, setBannerImage] = useState(null)
    const [bannerImage2, setBannerImage2] = useState(null)
    const [socialLinks, setSocialLinks] = useState([])
    const [newLinkName, setNewLinkName] = useState('')
    const [newLinkUrl, setNewLinkUrl] = useState('')
    const [editingLinkId, setEditingLinkId] = useState(null)
    const [editLinkName, setEditLinkName] = useState('')
    const [editLinkUrl, setEditLinkUrl] = useState('')
    const [newLinkNameError, setNewLinkNameError] = useState('')
    const [newLinkUrlError, setNewLinkUrlError] = useState('')
    const [editLinkNameError, setEditLinkNameError] = useState('')
    const [editLinkUrlError, setEditLinkUrlError] = useState('')
    const [loading, setLoading] = useState(false)
    const [youtubeVideos, setYoutubeVideos] = useState([])
    const [newVideoUrl, setNewVideoUrl] = useState('')
    const [newVideoName, setNewVideoName] = useState('')
    const [videoUrlError, setVideoUrlError] = useState('')
    const [videoNameError, setVideoNameError] = useState('')
    const [editingVideoId, setEditingVideoId] = useState(null)
    const [editVideoName, setEditVideoName] = useState('')
    const [editVideoNameError, setEditVideoNameError] = useState('')
    const [profileDragActive, setProfileDragActive] = useState(false)
    const [bannerDragActive, setBannerDragActive] = useState(false)
    const [isSelfDeleted, setIsSelfDeleted] = useState(false)
    const [userStatus, setUserStatus] = useState('Active')
    const dispatch = useDispatch()
    const navigate = useNavigate()

    console.log("profilePhoto", profilePhoto)
    console.log("profilePhoto2", profilePhoto2)

    const subscripetion_status = false;

    const toEnglishOnly = (value) => value.replace(/[^\x20-\x7E]/g, '');

    const formatDisplayDate = (date) => {
        if (!date) return ''
        const formattedDate = moment(date).locale('en').format('DD-MMM-YYYY')
        return formattedDate === 'Invalid date' ? '' : formattedDate
    }

    // Track dirty state


    // Font color function
    const handleFontColorSelect = (color) => {
        setSelectedFontColor(color)
        setIsDirty(true)
        // toast.info('Font Color Updated, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }
    const [isDirty, setIsDirty] = useState(false)

    // useBlocker hook for preventing navigation
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) =>
            isDirty && currentLocation.pathname !== nextLocation.pathname
    );

    useEffect(() => {
        if (blocker.state === "blocked" && isDirty) {
            Swal.fire({
                title: "Unsaved Changes",
                text: "Do you want to Update Changes or Not?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Update",
                cancelButtonText: "No, Discard",
                showDenyButton: true,
                denyButtonText: "Cancel",
                denyButtonColor: "#aaa",
            }).then((result) => {
                if (result.isConfirmed) {
                    updatebiolinkFunction().then(() => {
                        setIsDirty(false);
                        setTimeout(() => blocker.proceed(), 100);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    setIsDirty(false);
                    setTimeout(() => blocker.proceed(), 100);
                } else {
                    blocker.reset();
                }
            });
        }
    }, [blocker.state]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
                return e.returnValue;
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isDirty]);

    const video_analysis = (video) => {
        navigate('/video-analytics', { state: video })
    }

    const button_analysis = (link) => {
        navigate('/button-analytics', { state: link })
    }

    // Solid color options
    const solidColors = [
        { name: 'White', value: '#ffffff' },
        { name: 'Black', value: '#000000' },
        { name: 'Blue', value: '#3b82f6' },
        { name: 'Purple', value: '#8b5cf6' },
        { name: 'Pink', value: '#ec4899' },
        { name: 'Green', value: '#10b981' },
        { name: 'Red', value: '#ef4444' },
        { name: 'Orange', value: '#f97316' },
        { name: 'Yellow', value: '#facc15' },
        { name: 'Teal', value: '#14b8a6' },
        // { name: 'Gray', value: '#6b7280' },
        // { name: 'Indigo', value: '#6366f1' }
    ]

    // Gradient options
    const gradients = [
        { name: 'Green Blue', value: 'linear-gradient(180deg, #a7f3d0 0%, #bfdbfe 100%)' },
        { name: 'Purple Blue', value: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
        { name: 'Pink Orange', value: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
        { name: 'Blue Cyan', value: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
        { name: 'Green Teal', value: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' },
        { name: 'Orange Red', value: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' },
        { name: 'Sunset Glow', value: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)' },
        { name: 'Aqua Marine', value: 'linear-gradient(135deg, #5ee7df 0%, #b490ca 100%)' },
        // { name: 'Deep Space', value: 'linear-gradient(135deg, #2b5876 0%, #4e4376 100%)' },
        { name: 'Fresh Lime', value: 'linear-gradient(135deg, #a8ff78 0%, #78ffd6 100%)' },
        { name: 'Fireburst', value: 'linear-gradient(135deg, #f83600 0%, #f9d423 100%)' },
        // { name: 'Royal Purple', value: 'linear-gradient(135deg, #c471ed 0%, #f64f59 100%)' }
    ]

    // Font family options
    const fontFamilies = [
        { name: 'Arial', value: 'Arial, sans-serif' },
        { name: 'Roboto', value: "'Roboto', sans-serif" },
        { name: 'Open Sans', value: "'Open Sans', sans-serif" },
        { name: 'Montserrat', value: "'Montserrat', sans-serif" },
        { name: 'Lato', value: "'Lato', sans-serif" },
        { name: 'Poppins', value: "'Poppins', sans-serif" }
    ]

    // background type function
    const handleBackgroundTypeChange = (e) => {
        setBackgroundType(e.target.value)
        setIsDirty(true)
        // toast.info('Background Type Changed, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
        // Reset selection when switching types
        if (e.target.value === 'solid') {
            setSelectedBackground('#ffffff')
        } else {
            setSelectedBackground(gradients[0].value)
        }
    }

    // Solid Color function
    const handleColorSelect = (color) => {
        setSelectedBackground(color)
        setIsDirty(true)
        toast.info('Color Selected, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    // gradient Color function
    const handleGradientSelect = (gradient) => {
        setSelectedBackground(gradient)
        setIsDirty(true)
        // toast.info('Gradient Selected, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
        // Try to reverse engineer the gradient for the controls if possible, otherwise default
        // This is a simple heuristic and might not be perfect for complex gradients
        if (gradient.includes('linear-gradient')) {
            // For now, let's keep the custom controls independent unless selected
        }
    }

    const handleGradientColorChange = (type, value) => {
        let newColor1 = gradientColor1
        let newColor2 = gradientColor2
        let newDirection = gradientDirection
        let newType = gradientType

        if (type === 'color1') {
            setGradientColor1(value)
            newColor1 = value
        } else if (type === 'color2') {
            setGradientColor2(value)
            newColor2 = value
        } else if (type === 'direction') {
            setGradientDirection(value)
            newDirection = value
        } else if (type === 'type') {
            setGradientType(value)
            newType = value
            // Reset direction/position when switching types
            if (value === 'radial') {
                newDirection = 'center';
                setGradientDirection('center');
            } else {
                newDirection = 'to bottom';
                setGradientDirection('to bottom');
            }
        }

        let newGradient
        if (newType === 'radial') {
            // Ensure we use the current direction as position for radial
            const position = (newDirection.includes('deg') || newDirection.startsWith('to ')) ? 'center' : newDirection;
            newGradient = `radial-gradient(circle at ${position}, ${newColor1}, ${newColor2})`
        } else {
            // Ensure we use the current direction for linear
            const direction = (!newDirection.includes('deg') && !newDirection.startsWith('to ')) ? 'to bottom' : newDirection;
            newGradient = `linear-gradient(${direction}, ${newColor1}, ${newColor2})`
        }

        setSelectedBackground(newGradient)
        setIsDirty(true)
        // Only toast on discrete changes to avoid spamming during color slider movement
        if (type !== 'color1' && type !== 'color2') {
            // toast.info('Custom Gradient Updated, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
        }
    }

    // Font family function
    const handleFontFamilySelect = (fontFamily) => {
        setSelectedFontFamily(fontFamily)
        setIsDirty(true)
        // toast.info('Font Family Updated, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    // Shared file validation function
    const validateImageFile = (file) => {
        if (!file) return false
        const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif']
        const fileName = file.name.toLowerCase()
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'))
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error('Please upload only PNG, JPG, JPEG, or GIF format images', {
                position: "bottom-right"
            })
            return false
        }
        return true
    }

    // Process profile photo file (used by both input change and drag-drop)
    const processProfileFile = (file) => {
        if (!file || !validateImageFile(file)) return
        setProfilePhoto2(file)
        setIsDirty(true)
        const reader = new FileReader()
        reader.onloadend = () => {
            setProfilePhoto(reader.result)
        }
        reader.readAsDataURL(file)
    }

    // Profile function (input change)
    const handlePhotoUpload = (e) => {
        const file = e.target.files[0]
        if (!file) {
            setProfilePhoto(null)
            return
        }
        processProfileFile(file)
    }

    // Profile drag-and-drop handlers
    const handleProfileDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setProfileDragActive(true)
    }
    const handleProfileDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setProfileDragActive(false)
    }
    const handleProfileDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setProfileDragActive(false)
        const file = e.dataTransfer?.files?.[0]
        processProfileFile(file)
    }

    const handleRemovePhoto = () => {
        setProfilePhoto(null)
        setProfilePhoto2(null)
        setIsDirty(true)
    }

    // Process banner file (used by both input change and drag-drop)
    const processBannerFile = (file) => {
        if (!file || !validateImageFile(file)) return
        setBannerImage2(file)
        setIsDirty(true)
        const reader = new FileReader()
        reader.onloadend = () => {
            setBannerImage(reader.result)
        }
        reader.readAsDataURL(file)
    }

    // Banner function (input change)
    const handleBannerUpload = (e) => {
        const file = e.target.files[0]
        if (!file) {
            setBannerImage(null)
            return
        }
        processBannerFile(file)
    }

    // Banner drag-and-drop handlers
    const handleBannerDragOver = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setBannerDragActive(true)
    }
    const handleBannerDragLeave = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setBannerDragActive(false)
    }
    const handleBannerDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setBannerDragActive(false)
        const file = e.dataTransfer?.files?.[0]
        processBannerFile(file)
    }

    const handleRemoveBanner = () => {
        setBannerImage(null)
        setBannerImage2(null)
        setIsDirty(true)
    }

    // URL validation function
    const isValidUrl = (urlString) => {
        if (!urlString || !urlString.trim()) {
            return false
        }
        const trimmedUrl = urlString.trim()

        try {
            // Try to create URL object to validate
            let url = trimmedUrl
            if (!url.match(/^https?:\/\//i)) {
                url = 'https://' + url
            }
            const urlObj = new URL(url)
            // Basic check for protocol and hostname presence is handled by URL constructor
            // We just ensure it's http or https
            return urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
        } catch (e) {
            return false
        }
    }

    // Validate new link URL
    const validateNewLinkUrl = (url) => {
        const trimmedUrl = url.trim()
        if (!trimmedUrl) {
            setNewLinkUrlError('')
            return false
        }
        // Only validate if user has typed at least 3 characters (to avoid showing errors too early)
        if (trimmedUrl.length >= 3 && !isValidUrl(trimmedUrl)) {
            setNewLinkUrlError('Please enter a valid URL')
            return false
        }
        // If valid or too short to validate, clear error
        if (isValidUrl(trimmedUrl) || trimmedUrl.length < 3) {
            setNewLinkUrlError('')
        }
        return isValidUrl(trimmedUrl)
    }

    // Validate edit link URL
    const validateEditLinkUrl = (url) => {
        const trimmedUrl = url.trim()
        if (!trimmedUrl) {
            setEditLinkUrlError('Please enter a valid URL')
            return false
        }
        // Only validate if user has typed at least 3 characters (to avoid showing errors too early)
        if (trimmedUrl.length >= 3 && !isValidUrl(trimmedUrl)) {
            setEditLinkUrlError('Please enter a valid URL (e.g., https://example.com)')
            return false
        }
        // If valid or too short to validate, clear error
        if (isValidUrl(trimmedUrl) || trimmedUrl.length < 3) {
            setEditLinkUrlError('')
        }
        return isValidUrl(trimmedUrl)
    }

    // Handle new link URL change with validation
    const handleNewLinkUrlChange = (value) => {
        setNewLinkUrl(value)
        setNewLinkUrlError('')
        setIsDirty(true)
    }

    const handleEditLinkName = (value) => {
        setEditLinkName(value)
        setIsDirty(true)
        if (!value.trim()) {
            setEditLinkNameError('Please enter a button name')
        } else if (value.trim().length > 16) {
            setEditLinkNameError('Button name cannot exceed 16 characters')
        } else {
            setEditLinkNameError('')
        }
    }

    // Handle edit link URL change with validation
    const handleEditLinkUrlChange = (value) => {
        setEditLinkUrl(value)
        setEditLinkUrlError('')
        setIsDirty(true)
    }

    const handleUrlNameChange = (value) => {
        setNewLinkName(value)
        setIsDirty(true)
        if (!value.trim()) {
            setNewLinkNameError('Please enter a button name')
        } else if (value.trim().length > 16) {
            setNewLinkNameError('Button name cannot exceed 16 characters')
        } else {
            setNewLinkNameError('')
        }
    }

    // Social Link  function
    const handleAddSocialLink = () => {
        if (!newLinkName.trim()) {
            setNewLinkNameError('Please enter a link name')
            return
        }
        if (newLinkName.trim().length > 16) {
            setNewLinkNameError('Link name cannot exceed 16 characters')
            return
        }
        if (!newLinkUrl.trim()) {
            setNewLinkUrlError('Please enter a URL')
            // toast.error('Please enter a URL', { position: "bottom-right" })
            return
        }
        if (!validateNewLinkUrl(newLinkUrl.trim())) {
            toast.error('Please enter a valid URL (e.g., https://example.com)', { position: "bottom-right" })
            return
        }

        const trimmedUrl = newLinkUrl.trim()
        const normalizedUrlToCheck = trimmedUrl.replace(/\/$/, '').toLowerCase()
        if (!normalizedUrlToCheck.startsWith('http')) {
            // Check both versions (with and without https) just in case
        }

        const isDuplicate = socialLinks.some(link => {
            if (link.social_status === 'deleted') return false
            const existingUrl = link.url.replace(/\/$/, '').toLowerCase()
            return existingUrl === normalizedUrlToCheck ||
                existingUrl === 'https://' + normalizedUrlToCheck ||
                'https://' + existingUrl === normalizedUrlToCheck
        })
        if (isDuplicate) {
            setNewLinkUrlError('This link is already added')
            toast.error('This link is already added', { position: "bottom-right" })
            return
        }
        // Normalize URL - add https:// if missing
        dispatch(checkSocialLinkURL({ url: newLinkUrl })).then((res) => {
            setSpinner(false);
            if (res.payload?.data?.data?.[0]?.is_embeddable === true) {
                let normalizedUrl = newLinkUrl.trim()
                if (!normalizedUrl.match(/^https?:\/\//i)) {
                    normalizedUrl = 'https://' + normalizedUrl
                }
                setSocialLinks([...socialLinks, {
                    id: Date.now(), name: newLinkName.trim(), url: normalizedUrl, is_hidden: false, total_clicks: 0
                }])
                setIsDirty(true)
                setNewLinkName('')
                setNewLinkUrl('')
                setNewLinkUrlError('')
                toast.success('Link Added, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
            } else {
                toast.error(res.payload?.data?.message || 'Invalid Content URL', { position: "bottom-right" });
            }
        }
        )
    }

    const handleRemoveSocialLink = (id) => {
        setSocialLinks(socialLinks.map(link => {
            const linkId = link.id || link._id
            if (linkId === id) {
                return { ...link, social_status: 'deleted' }
            }
            return link
        }))
        setIsDirty(true)
        toast.success('Link Removed, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    const handleEditSocialLink = (link) => {
        // Use id or _id as the identifier
        setEditingLinkId(link.id || link._id)
        setEditLinkName(link.name)
        setEditLinkUrl(link.url)
        setEditLinkUrlError('')
    }

    const handleSaveEdit = () => {
        if (!editLinkName.trim()) {
            setEditLinkNameError('Please enter a link name')
            toast.error('Please enter a link name', { position: "bottom-right" })
            return
        }
        if (editLinkName.trim().length > 16) {
            setEditLinkNameError('Link name cannot exceed 16 characters')
            toast.error('Link name cannot exceed 16 characters', { position: "bottom-right" })
            return
        }

        setSocialLinks(socialLinks.map(link => {
            const linkId = link.id || link._id
            if (linkId === editingLinkId) {
                return { ...link, name: editLinkName.trim() }
            }
            return link
        }))
        setIsDirty(true)
        setEditingLinkId(null)
        setEditLinkName('')
        setEditLinkUrl('')
        setEditLinkUrlError('')
        toast.success('Button Updated, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    const handleCancelEdit = () => {
        setEditingLinkId(null)
        setEditLinkName('')
        setEditLinkUrl('')
        setEditLinkUrlError('')
    }

    const handleToggleSocialLinkVisibility = (id) => {
        setSocialLinks(socialLinks.map(link => {
            const linkId = link.id || link._id;
            if (linkId === id) {
                const currentValue = link.is_hidden === true || link.is_hidden === 'true';
                return { ...link, is_hidden: !currentValue };
            }
            return link;
        }));
        setIsDirty(true)
    }

    // YouTube video helper functions
    const extractYouTubeId = (url) => {
        if (!url || !url.trim()) return null

        const trimmedUrl = url.trim()

        // YouTube Shorts URL pattern: youtube.com/shorts/VIDEO_ID
        const shortsPattern = /youtube\.com\/shorts\/([^&\n?#]+)/
        const shortsMatch = trimmedUrl.match(shortsPattern)
        if (shortsMatch) return shortsMatch[1]

        // Regular YouTube URL patterns
        const patterns = [
            /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
            /^([a-zA-Z0-9_-]{11})$/
        ]

        for (const pattern of patterns) {
            const match = trimmedUrl.match(pattern)
            if (match) return match[1] || match[0]
        }

        return null
    }

    const getYouTubeThumbnail = (video_id) => {
        return `https://img.youtube.com/vi/${video_id}/maxresdefault.jpg`
    }



    // Video functions (YouTube and other platforms)
    const handleAddYouTubeVideo = () => {
        // Validate video name
        if (!newVideoName.trim()) {
            setVideoNameError('Please enter a Content name')
            // toast.error('Please enter a video name', { position: "bottom-right" })
            return
        }

        if (newVideoName.trim().length > 65) {
            setVideoNameError('Content name cannot exceed 65 characters')
            // toast.error('Video name cannot exceed 75 characters', { position: "bottom-right" })
            return
        }

        // Validate video URL
        if (!newVideoUrl.trim()) {
            setVideoUrlError('Please enter a Content URL')
            // toast.error('Please enter a video URL', { position: "bottom-right" })
            return
        }

        const trimmedUrl = newVideoUrl.trim()

        // Check if it's a YouTube URL
        const video_id = extractYouTubeId(trimmedUrl)
        const isYouTube = video_id !== null

        // Check if video already exists
        let existingVideo
        if (isYouTube) {
            existingVideo = youtubeVideos.find(video => video.video_id === video_id)
        } else {
            // For non-YouTube videos, check by URL
            existingVideo = youtubeVideos.find(video => video.url === trimmedUrl)
        }

        if (existingVideo) {
            setVideoUrlError('This Content is already added')
            toast.error('This Content is already added', { position: "bottom-right" })
            return
        }

        dispatch(checkSocialLinkURL({ url: trimmedUrl })).then((res) => {

            setSpinner(false);
            if (res.payload?.data?.data?.[0]?.is_embeddable === true) {
                let videoData = {
                    id: Date.now(),
                    url_name: newVideoName.trim(),
                    url: trimmedUrl.startsWith('http') ? trimmedUrl : `https://${trimmedUrl}`,
                    is_hidden: false
                }

                if (isYouTube) {
                    // YouTube specific data
                    videoData.video_id = video_id
                    videoData.thumbnail = getYouTubeThumbnail(video_id)
                } else {
                    // For other video platforms, use a generic thumbnail or no thumbnail
                    videoData.video_id = null
                    videoData.thumbnail = null // Or use a generic video icon/placeholder
                }

                setYoutubeVideos([...youtubeVideos, videoData])
                setIsDirty(true)
                setNewVideoUrl('')
                setNewVideoName('')
                setVideoUrlError('')
                setVideoNameError('')
                toast.success('Content Added, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
            } else {
                toast.error(res.payload?.data?.message || 'Invalid Content URL', { position: "bottom-right" });
            }
        }
        )

        // Prepare video data

    }

    const handleRemoveVideo = (id) => {
        setYoutubeVideos(youtubeVideos.map(video => {
            if (video.id === id) {
                return { ...video, youtube_status: 'deleted' }
            }
            return video
        }))
        setIsDirty(true)
        toast.success('Content Removed, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    const handleToggleVideoVisibility = (id) => {
        setYoutubeVideos(youtubeVideos.map(video => {
            if (video.id === id) {
                // If is_hidden is undefined or false, set it to true (hide). If true, set to false (show)
                const currentValue = video.is_hidden === true || video.is_hidden === 'true'
                return { ...video, is_hidden: !currentValue }
            }
            return video
        }))
        setIsDirty(true)
    }

    const handleVideoUrlChange = (value) => {
        setNewVideoUrl(value)
        setVideoUrlError('')
        setIsDirty(true)
    }

    const handleVideoNameChange = (value) => {
        setNewVideoName(value)
        setIsDirty(true)
        if (value.trim().length > 64) {
            setVideoNameError('Content name cannot exceed 64 characters')
        } else {
            setVideoNameError('')
        }
    }

    const handleEditVideo = (video) => {
        setEditingVideoId(video.id)
        setEditVideoName(video.url_name)
        setEditVideoNameError('')
    }

    const handleEditVideoName = (value) => {
        setEditVideoName(value)
        setIsDirty(true)
        if (!value.trim()) {
            setEditVideoNameError('Please enter a content name')
        } else if (value.trim().length > 64) {
            setEditVideoNameError('Content name cannot exceed 64 characters')
        } else {
            setEditVideoNameError('')
        }
    }

    const handleSaveVideoEdit = () => {
        if (!editVideoName.trim()) {
            setEditVideoNameError('Please enter a content name')
            toast.error('Please enter a content name', { position: "bottom-right" })
            return
        }
        if (editVideoName.trim().length > 64) {
            setEditVideoNameError('Content name cannot exceed 64 characters')
            toast.error('Content name cannot exceed 64 characters', { position: "bottom-right" })
            return
        }

        setYoutubeVideos(youtubeVideos.map(video => {
            if (video.id === editingVideoId) {
                return { ...video, url_name: editVideoName.trim() }
            }
            return video
        }))
        setIsDirty(true)
        setEditingVideoId(null)
        setEditVideoName('')
        setEditVideoNameError('')
        toast.success('Content Updated, Click ‘Update Bio Page’ to save changes', { position: "bottom-right" })
    }

    const handleCancelVideoEdit = () => {
        setEditingVideoId(null)
        setEditVideoName('')
        setEditVideoNameError('')
    }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        // Separate visible and deleted videos
        const visibleVideos = youtubeVideos.filter(video => video.youtube_status !== 'deleted');
        const deletedVideos = youtubeVideos.filter(video => video.youtube_status === 'deleted');

        // Reorder visible videos
        const [reorderedItem] = visibleVideos.splice(result.source.index, 1);
        visibleVideos.splice(result.destination.index, 0, reorderedItem);

        // Merge back and update state
        setYoutubeVideos([...visibleVideos, ...deletedVideos]);
        setIsDirty(true)
    }

    const handleOnSocialDragEnd = (result) => {
        if (!result.destination) return;

        const visibleLinks = socialLinks.filter(link => link.social_status !== 'deleted');
        const deletedLinks = socialLinks.filter(link => link.social_status === 'deleted');

        const [reorderedItem] = visibleLinks.splice(result.source.index, 1);
        visibleLinks.splice(result.destination.index, 0, reorderedItem);

        setSocialLinks([...visibleLinks, ...deletedLinks]);
        setIsDirty(true)
    }

    // json object  function
    const biolinkJSON = {
        "showProfilePhoto": showProfilePhoto,
        "showTitle": showTitle,
        "showParagraph": showParagraph,
        "showBanner": showBanner,
        "profilePhoto": profilePhoto2,
        "title": title,
        "about_us": paragraph,
        "bannerImage": bannerImage2,
        "backgroundType": backgroundType,
        "background_color": selectedBackground,
        "font_family": selectedFontFamily,
        "font_color": selectedFontColor,
        "social_links": socialLinks,
        "youtube_videos": youtubeVideos
    }

    // API Dispatch Section
    const updatebiolinkFunction = () => {
        // Validate character limits before updating
        if (title?.length > 100) {
            toast.error('Title cannot exceed 100 characters. Please reduce the title length.', { position: "bottom-right" })
            return Promise.reject('Limit exceeded')
        }
        if (paragraph?.length > 256) {
            toast.error('About Us cannot exceed 256 characters. Please reduce the content length.', { position: "bottom-right" })
            return Promise.reject('Limit exceeded')
        }

        setSpinner(true)
        return dispatch(updateBioLink(biolinkJSON)).then((res) => {
            update_res(res.payload)
            return res.payload
        })
    }

    const update_res = (res) => {
        if (res?.status == 200 || res?.status == 201) {
            toast.success(res?.data?.message, { position: "bottom-right" })
            setSpinner(false)
            setBool(!bool)
            setIsDirty(false)
        } else if (res?.status == 400) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        }
        else if (res?.status == 404) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else if (res?.status == 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(bioLinkDetails({ navigate })).then((res) => list_res(res.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status == 200) {
            console.log(res)
            if (res?.data?.status === true) {
                const linkData = res?.data?.data?.[0]?.[0]
                localStorage.setItem('profile_photo', linkData?.profile_photo)
                localStorage.setItem('title', linkData?.title)
                localStorage.setItem('biolink_status', linkData?.user_details?.biolink_status)
                localStorage.setItem('biolink_expire_date', linkData?.user_details?.biolink_expire_date)
                setIsSelfDeleted(linkData?.user_details?.is_self_deleted === true)
                setUserStatus(linkData?.user_details?.status || linkData?.user_details?.user_status || 'Active')
                window.dispatchEvent(new Event('userDataUpdated'));
                setBackgroundType(linkData?.background_type || 'solid')
                setSelectedBackground(linkData?.background_color || '#ffffff')
                setSelectedFontFamily(linkData?.font_family || 'Arial, sans-serif')
                setSelectedFontColor(linkData?.font_color || '#000000')
                setProfilePhoto(linkData?.profile_photo ? process.env.REACT_APP_BASE_URL + linkData?.profile_photo : null)
                setProfilePhoto2(linkData?.profile_photo ? process.env.REACT_APP_BASE_URL + linkData?.profile_photo : null)
                setTitle(linkData?.title)
                setParagraph(linkData?.about_us)
                setBannerImage(linkData?.banner_image ? process.env.REACT_APP_BASE_URL + linkData?.banner_image : null)
                setBannerImage2(linkData?.banner_image ? process.env.REACT_APP_BASE_URL + linkData?.banner_image : null)
                setShowTitle(linkData?.show_title)
                setShowParagraph(linkData?.show_paragraph)
                setShowProfilePhoto(linkData?.show_profile_photo)
                setShowBanner(linkData?.show_banner)
                // Normalize social links: convert _id to id for consistency
                const normalizedLinks = linkData?.social_links?.map(link => ({
                    ...link,
                    id: link._id || link.id || Date.now() + Math.random(), // Use _id as id, fallback to id or generate new
                    is_hidden: link.is_hidden === true || link.is_hidden === 'true',
                    social_status: link.social_status || link.status,
                    total_clicks: link.total_clicks || 0,
                })) || []
                setSocialLinks(normalizedLinks)

                // Load YouTube videos if available
                let normalizedVideos = []
                if (linkData?.youtube_videos && Array.isArray(linkData.youtube_videos)) {
                    normalizedVideos = linkData.youtube_videos.map(video => ({
                        ...video,
                        id: video._id || video.id || Date.now() + Math.random(),
                        video_id: video.video_id || extractYouTubeId(video.url),
                        total_clicks: video.total_clicks || 0,
                        url_name: video.url_name || 'Content',
                        thumbnail: video.thumbnail || (video.video_id || video.video_id ? getYouTubeThumbnail(video.video_id || video.video_id) : ''),
                        is_hidden: video.is_hidden === true || video.is_hidden === 'true'
                    }))
                    setYoutubeVideos(normalizedVideos)
                }

                setIsDirty(false);
            }

            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const profile_update = () => {
        setShow(true)
    }

    const subscription_fun = () => {
        setShow2(true)
    }

    const [mobileTab, setMobileTab] = useState('editor') // 'editor' or 'preview'

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2'>
                            <h5 className='mb-0'>Bio Page</h5>
                            <div className='d-flex align-items-center flex-wrap gap-2'>
                                {localStorage.getItem('biolink_status') === 'paid' ? <h6 className='mb-0 small'>SUBSCRIBER TILL :- {formatDisplayDate(localStorage.getItem('biolink_expire_date'))}</h6> 
                                : ''}
                                <button className='btn btn-sm btn-primary' onClick={() => profile_update()}>Profile Update</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile View Toggle Buttons */}
                <div className="d-xl-none mb-3">
                    <div className="biolink-mobile-nav">
                        <button
                            className={`biolink-mobile-nav-btn ${mobileTab === 'editor' ? 'active' : ''}`}
                            onClick={() => setMobileTab('editor')}
                        >
                            <Edit2 size={16} />
                            <span>Editor</span>
                        </button>
                        <button
                            className={`biolink-mobile-nav-btn ${mobileTab === 'preview' ? 'active' : ''}`}
                            onClick={() => setMobileTab('preview')}
                        >
                            <Eye size={20} color='green' />
                            <span>Preview</span>
                        </button>
                    </div>
                </div>

                {loading ?
                    <div div className='layout d-flex justify-content-center p-5 mb-4'>
                        <Loader />
                    </div>
                    :
                    <div className="row mb-5">
                        {/* Left Section - Customization Form */}
                        <div className={`col-xl-7 ${mobileTab === 'preview' ? 'd-none d-xl-block' : ''}`}>
                            <div className="biolink-customization-panel content">
                                <div className="biolink-tab-buttons">
                                    <button
                                        className={`biolink-tab-button ${activeTab === 'settings' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('settings')}
                                    >
                                        <Settings size={18} />
                                        <span>Settings</span>
                                    </button>
                                    <button
                                        className={`biolink-tab-button ${activeTab === 'blocks' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('blocks')}
                                    >
                                        <SquareStack size={18} />
                                        <span>Page</span>
                                    </button>
                                </div>

                                {activeTab === 'settings' && (
                                    <div className="biolink-settings-content">
                                        <h5 className='text-center'>Customizations</h5>
                                        <Form.Group className="mb-4">
                                            <Form.Label>Background Type</Form.Label>
                                            <Form.Select
                                                value={backgroundType}
                                                onChange={handleBackgroundTypeChange}
                                            >
                                                <option value="solid">Solid</option>
                                                <option value="gradient">Gradient</option>
                                            </Form.Select>
                                        </Form.Group>

                                        {backgroundType == 'solid' && (
                                            <div className="biolink-color-picker">
                                                <Form.Label className="mb-2">Select Color</Form.Label>
                                                <div className="biolink-color-picker-wrapper">
                                                    <div className="biolink-custom-color-picker">
                                                        <Form.Label className="mb-2">Custom Color</Form.Label>
                                                        <div className="biolink-color-input-wrapper">
                                                            <input
                                                                type="color"
                                                                value={/^#[0-9A-F]{6}$/i.test(selectedBackground) ? selectedBackground : '#ffffff'}
                                                                onChange={(e) => handleColorSelect(e.target.value)}
                                                                className="biolink-color-input"
                                                            />
                                                            <input
                                                                type="text"
                                                                value={selectedBackground}
                                                                onChange={(e) => handleColorSelect(e.target.value)}
                                                                className="biolink-color-text-input"
                                                                placeholder="#ffffff"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="biolink-preset-colors">
                                                        <Form.Label className="mb-2">Preset Colors</Form.Label>
                                                        <div className="biolink-color-grid">
                                                            {solidColors.map((color, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`biolink-color-box ${selectedBackground === color.value ? 'active' : ''}`}
                                                                    style={{ backgroundColor: color.value }}
                                                                    onClick={() => handleColorSelect(color.value)}
                                                                    title={color.name}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {backgroundType === 'gradient' && (
                                            <div className="biolink-gradient-picker">
                                                <div className="biolink-custom-gradient-generator mb-4">
                                                    <Form.Label className="mb-2">Create Custom Gradient</Form.Label>
                                                    <div className="d-flex flex-wrap gap-2 align-items-end">
                                                        <div className="flex-grow-1">
                                                            <Form.Label className="small text-muted mb-1">Color 1</Form.Label>
                                                            <div className="biolink-color-input-wrapper">
                                                                <input
                                                                    type="color"
                                                                    value={/^#[0-9A-F]{6}$/i.test(gradientColor1) ? gradientColor1 : '#ffffff'}
                                                                    onChange={(e) => handleGradientColorChange('color1', e.target.value)}
                                                                    className="biolink-color-input"
                                                                />
                                                                <input
                                                                    type="text"
                                                                    value={gradientColor1}
                                                                    onChange={(e) => handleGradientColorChange('color1', e.target.value)}
                                                                    className="biolink-color-text-input"
                                                                    placeholder="#000000"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <Form.Label className="small text-muted mb-1">Color 2</Form.Label>
                                                            <div className="biolink-color-input-wrapper">
                                                                <input
                                                                    type="color"
                                                                    value={/^#[0-9A-F]{6}$/i.test(gradientColor2) ? gradientColor2 : '#000000'}
                                                                    onChange={(e) => handleGradientColorChange('color2', e.target.value)}
                                                                    className="biolink-color-input"
                                                                />
                                                                <input
                                                                    type="text"
                                                                    value={gradientColor2}
                                                                    onChange={(e) => handleGradientColorChange('color2', e.target.value)}
                                                                    className="biolink-color-text-input"
                                                                    placeholder="#000000"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div style={{ minWidth: '140px' }}>
                                                            <Form.Label className="small text-muted mb-1">Type</Form.Label>
                                                            <Form.Select
                                                                value={gradientType}
                                                                onChange={(e) => handleGradientColorChange('type', e.target.value)}
                                                                className="form-select bg-white"
                                                                style={{ height: '50px' }}
                                                            >
                                                                <option value="linear">Linear</option>
                                                                <option value="radial">Radial</option>
                                                            </Form.Select>
                                                        </div>
                                                        {gradientType === 'linear' ? (
                                                            <div style={{ minWidth: '140px' }}>
                                                                <Form.Label className="small text-muted mb-1">Direction</Form.Label>
                                                                <Form.Select
                                                                    value={gradientDirection}
                                                                    onChange={(e) => handleGradientColorChange('direction', e.target.value)}
                                                                    className="form-select bg-white"
                                                                    style={{ height: '50px' }}
                                                                >
                                                                    <option value="to bottom">↓ Bottom</option>
                                                                    <option value="to top">↑ Top</option>
                                                                    <option value="to right">→ Right</option>
                                                                    <option value="to left">← Left</option>
                                                                    <option value="135deg">↘ Diagonal 1</option>
                                                                    <option value="45deg">↗ Diagonal 2</option>
                                                                    <option value="225deg">↙ Diagonal 3</option>
                                                                    <option value="315deg">↖ Diagonal 4</option>
                                                                </Form.Select>
                                                            </div>
                                                        ) : (
                                                            <div style={{ minWidth: '140px' }}>
                                                                <Form.Label className="small text-muted mb-1">Position</Form.Label>
                                                                <Form.Select
                                                                    value={gradientDirection}
                                                                    onChange={(e) => handleGradientColorChange('direction', e.target.value)}
                                                                    className="form-select bg-white"
                                                                    style={{ height: '50px' }}
                                                                >
                                                                    <option value="center">Center</option>
                                                                    <option value="top">Top</option>
                                                                    <option value="bottom">Bottom</option>
                                                                    <option value="left">Left</option>
                                                                    <option value="right">Right</option>
                                                                    <option value="top left">Top Left</option>
                                                                    <option value="top right">Top Right</option>
                                                                    <option value="bottom left">Bottom Left</option>
                                                                    <option value="bottom right">Bottom Right</option>
                                                                </Form.Select>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="mt-3 p-3 rounded border" style={{ background: gradientType === 'radial' ? `radial-gradient(circle at ${gradientDirection.includes('deg') || gradientDirection.startsWith('to ') ? 'center' : gradientDirection}, ${gradientColor1}, ${gradientColor2})` : `linear-gradient(${!gradientDirection.includes('deg') && !gradientDirection.startsWith('to ') ? 'to bottom' : gradientDirection}, ${gradientColor1}, ${gradientColor2})`, height: '60px' }}>
                                                        <p className="text-center text-white mb-0 small" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>Preview</p>
                                                    </div>
                                                </div>

                                                <Form.Label className="mb-2">Preset Gradients</Form.Label>
                                                <div className="biolink-gradient-grid">
                                                    {gradients.map((gradient, index) => (
                                                        <div
                                                            key={index}
                                                            className={`biolink-gradient-box ${selectedBackground === gradient.value ? 'active' : ''}`}
                                                            style={{ background: gradient.value }}
                                                            onClick={() => handleGradientSelect(gradient.value)}
                                                            title={gradient.name}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className="biolink-font-picker">
                                            <Form.Label className="mb-2">Font Family</Form.Label>
                                            <div className="biolink-font-grid">
                                                {fontFamilies.map((font, index) => (
                                                    <div
                                                        key={index}
                                                        className={`biolink-font-box ${selectedFontFamily === font.value ? 'active' : ''}`}
                                                        onClick={() => handleFontFamilySelect(font.value)}
                                                        title={font.name}
                                                        style={{ fontFamily: font.value }}
                                                    >
                                                        {font.name}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="biolink-font-color-picker mt-4">
                                            <Form.Label className="mb-2">Font Color</Form.Label>
                                            <div className="biolink-color-picker-wrapper">
                                                <div className="biolink-custom-color-picker">
                                                    <Form.Label className="mb-2">Custom Color</Form.Label>
                                                    <div className="biolink-color-input-wrapper">
                                                        <input
                                                            type="color"
                                                            value={/^#[0-9A-F]{6}$/i.test(selectedFontColor) ? selectedFontColor : '#000000'}
                                                            onChange={(e) => handleFontColorSelect(e.target.value)}
                                                            className="biolink-color-input"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={selectedFontColor}
                                                            onChange={(e) => handleFontColorSelect(e.target.value)}
                                                            className="biolink-color-text-input"
                                                            placeholder="#000000"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="biolink-preset-colors">
                                                    <Form.Label className="mb-2">Preset Colors</Form.Label>
                                                    <div className="biolink-color-grid">
                                                        {solidColors.map((color, index) => (
                                                            <div
                                                                key={index}
                                                                className={`biolink-color-box ${selectedFontColor === color.value ? 'active' : ''}`}
                                                                style={{ backgroundColor: color.value }}
                                                                onClick={() => handleFontColorSelect(color.value)}
                                                                title={color.name}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'blocks' && (
                                    <div className="biolink-blocks-content">
                                        <h6 className="mb-3">Profile Photo <span className='text-secondary fs-8'>(image size should in 1:1 aspect ratio for better visibility)</span></h6>

                                        {!profilePhoto ? (
                                            <div className="biolink-photo-upload-section d-flex align-items-center">
                                                <Form.Group>
                                                    {/* <Form.Label>Upload Profile Photo</Form.Label> */}
                                                    <div
                                                        className={`biolink-upload-area ${profileDragActive ? 'drag-active' : ''}`}
                                                        onDragOver={handleProfileDragOver}
                                                        onDragEnter={handleProfileDragOver}
                                                        onDragLeave={handleProfileDragLeave}
                                                        onDrop={handleProfileDrop}
                                                    >
                                                        <input
                                                            type="file"
                                                            accept=".png, .jpg, .jpeg, .gif"
                                                            onChange={handlePhotoUpload}
                                                            className="biolink-file-input"
                                                            id="profile-photo-upload"
                                                        />
                                                        <label htmlFor="profile-photo-upload" className="biolink-upload-label">
                                                            <Upload size={24} />
                                                            <span>Click to upload or drag and drop</span>
                                                            <small>PNG, JPG, JPEG, GIF only</small>
                                                            <p className='mb-0'> (Maximum file size: 512 KB.)</p>
                                                        </label>
                                                    </div>

                                                </Form.Group>
                                                <button
                                                    className={'btn btn-sm ms-3'}
                                                    style={{ borderRadius: '8px', border: showProfilePhoto === true || showProfilePhoto === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                    onClick={() => {
                                                        showProfilePhoto === true || showProfilePhoto === "true" ? setShowProfilePhoto(false) : setShowProfilePhoto(true);
                                                        setIsDirty(true);
                                                    }}
                                                >
                                                    {showProfilePhoto === true || showProfilePhoto === 'true' ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                    {/* <span>{showBanner ? 'Hide Banner' : 'Show Banner'}</span> */}
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="biolink-photo-preview-section">
                                                {/* <Form.Label className="mb-2">Profile Photo Preview</Form.Label> */}
                                                <div className="biolink-photo-preview-container">
                                                    <div className="biolink-photo-preview">
                                                        <img src={profilePhoto} alt="Profile" />
                                                        <button
                                                            className="biolink-remove-photo-btn"
                                                            onClick={handleRemovePhoto}
                                                            title="Remove photo"
                                                        >
                                                            <X size={18} />
                                                        </button>
                                                    </div>
                                                    <div className="biolink-photo-actions">
                                                        <label htmlFor="change-photo-upload" className="btn btn-sm" style={{ border: 'solid 1px grey', borderRadius: '8px' }}>
                                                            <Edit size={16} color='grey' />
                                                            {/* <span>Change Photo</span> */}
                                                            <input
                                                                type="file"
                                                                accept=".png, .jpg, .jpeg, .gif"
                                                                onChange={handlePhotoUpload}
                                                                className="biolink-file-input"
                                                                id="change-photo-upload"
                                                                style={{ display: 'none' }}
                                                            />
                                                        </label>
                                                        <button
                                                            className={'btn btn-sm'}
                                                            style={{ borderRadius: '8px', border: showProfilePhoto === true || showProfilePhoto === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                            onClick={() => {
                                                                showProfilePhoto === true || showProfilePhoto === "true" ? setShowProfilePhoto(false) : setShowProfilePhoto(true);
                                                                setIsDirty(true);
                                                            }}
                                                        >
                                                            {showProfilePhoto === true || showProfilePhoto === 'true' ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                            {/* <span>{showBanner ? 'Hide Banner' : 'Show Banner'}</span> */}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="biolink-title-section">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <Form.Label className="mb-0"> Display Name</Form.Label>
                                                <button
                                                    className={'btn btn-sm'}
                                                    style={{ borderRadius: '8px', border: showTitle === true || showTitle === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                    onClick={() => {
                                                        showTitle === true || showTitle === 'true' ? setShowTitle(false) : setShowTitle(true);
                                                        setIsDirty(true);
                                                    }}
                                                    type="button"
                                                >
                                                    {showTitle === true || showTitle === 'true' ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                    {/* <span>{showTitle ? 'Hide Title' : 'Show Title'}</span> */}
                                                </button>
                                            </div>
                                            <Form.Group className="mb-3">
                                                <Form.Control
                                                    type="text"
                                                    value={title}
                                                    onChange={(e) => {
                                                        setTitle(toEnglishOnly(e.target.value));
                                                        setIsDirty(true);
                                                    }}
                                                    placeholder="Enter title"
                                                    className={`biolink-title-input ${title?.length > 64 ? 'is-invalid' : ''}`}
                                                    maxLength={64}
                                                />
                                                <Form.Text className={title?.length > 64 ? 'text-danger' : 'text-muted'} style={{ fontSize: '12px' }}>
                                                    {title?.length}/64 characters {title?.length > 64 && '(Exceeds limit)'}
                                                </Form.Text>
                                                {title?.length > 64 && (
                                                    <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                        Title cannot exceed 64 characters
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </div>

                                        <div className="biolink-paragraph-section">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <Form.Label className="mb-0">About Me</Form.Label>
                                                <button
                                                    className={'btn btn-sm'}
                                                    style={{ borderRadius: '8px', border: showParagraph === true || showParagraph === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                    onClick={() => {
                                                        showParagraph === true || showParagraph === "true" ? setShowParagraph(false) : setShowParagraph(true);
                                                        setIsDirty(true);
                                                    }}
                                                    type="button"
                                                >
                                                    {showParagraph === true || showParagraph === "true" ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                    {/* <span>{showParagraph ? 'Hide Paragraph' : 'Show Paragraph'}</span> */}
                                                </button>
                                            </div>
                                            <Form.Group className="mb-3">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={paragraph}
                                                    onChange={(e) => {
                                                        setParagraph(e.target.value);
                                                        setIsDirty(true);
                                                    }}
                                                    placeholder="Enter paragraph text"
                                                    className={`biolink-paragraph-input ${paragraph?.length > 256 ? 'is-invalid' : ''}`}
                                                    maxLength={256}
                                                />
                                                <Form.Text className={paragraph?.length > 256 ? 'text-danger' : 'text-muted'} style={{ fontSize: '12px' }}>
                                                    {paragraph?.length}/256 characters {paragraph?.length > 256 && '(Exceeds limit)'}
                                                </Form.Text>
                                                {paragraph?.length > 256 && (
                                                    <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                        About Me cannot exceed 256 characters
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </div>

                                        <div className="biolink-banner-section">
                                            <h6 className="mb-3">Banner <span className='text-secondary fs-8'>(image size should in 16:9 aspect ratio for better visibility)</span></h6>

                                            {bannerImage === null ?
                                                <div className="biolink-banner-upload-section d-flex align-items-center">
                                                    <Form.Group>
                                                        <div
                                                            className={`biolink-upload-area ${bannerDragActive ? 'drag-active' : ''}`}
                                                            onDragOver={handleBannerDragOver}
                                                            onDragEnter={handleBannerDragOver}
                                                            onDragLeave={handleBannerDragLeave}
                                                            onDrop={handleBannerDrop}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept=".png, .jpg, .jpeg, .gif"
                                                                onChange={handleBannerUpload}
                                                                className="biolink-file-input"
                                                                id="banner-upload"
                                                            />
                                                            <label htmlFor="banner-upload" className="biolink-upload-label">
                                                                <Upload size={24} />
                                                                <span>Click to upload banner or drag and drop</span>
                                                                <small className='mb-0'>PNG, JPG, JPEG, GIF only</small>
                                                                <p className='mb-0'> (Maximum file size: 2 MB.)</p>
                                                            </label>
                                                        </div>
                                                    </Form.Group>
                                                    <button
                                                        className={'btn btn-sm ms-3'}
                                                        style={{ borderRadius: '8px', border: showBanner === true || showBanner === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                        onClick={() => {
                                                            showBanner === true || showBanner === "true" ? setShowBanner(false) : setShowBanner(true);
                                                            setIsDirty(true);
                                                        }}
                                                    >
                                                        {showBanner === true || showBanner === 'true' ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                        {/* <span>{showBanner ? 'Hide Banner' : 'Show Banner'}</span> */}
                                                    </button>
                                                </div>
                                                :
                                                <div className="biolink-banner-preview-section">
                                                    <div className="biolink-banner-preview-container">
                                                        <div className="biolink-banner-preview">
                                                            <img src={bannerImage} alt="Banner" />
                                                            <button
                                                                className="biolink-remove-banner-btn"
                                                                onClick={handleRemoveBanner}
                                                                title="Remove banner"
                                                            >
                                                                <X size={18} />
                                                            </button>
                                                        </div>
                                                        <div className="biolink-banner-actions">
                                                            <label htmlFor="change-banner-upload" className="btn btn-sm" style={{ border: 'solid 1px grey', borderRadius: '8px' }}>
                                                                <Edit size={16} color='grey' />
                                                                {/* <span>Change Banner</span> */}
                                                                <input
                                                                    type="file"
                                                                    accept=".png, .jpg, .jpeg, .gif"
                                                                    onChange={handleBannerUpload}
                                                                    className="biolink-file-input"
                                                                    id="change-banner-upload"
                                                                    style={{ display: 'none' }}
                                                                />
                                                            </label>
                                                            <button
                                                                className={'btn btn-sm'}
                                                                style={{ borderRadius: '8px', border: showBanner === true || showBanner === "true" ? 'solid 1px green' : 'solid 1px red' }}
                                                                onClick={() => {
                                                                    showBanner === true || showBanner === "true" ? setShowBanner(false) : setShowBanner(true);
                                                                    setIsDirty(true);
                                                                }}
                                                            >
                                                                {showBanner === true || showBanner === 'true' ? <Eye size={16} color='green' className='mb-1' /> : <EyeOff size={16} color='red' className='mb-1' />}
                                                                {/* <span>{showBanner ? 'Hide Banner' : 'Show Banner'}</span> */}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className="biolink-youtube-videos-section">
                                            <h6 className="mb-3">Content</h6>

                                            <div className="biolink-add-video-form">
                                                <div className="row mb-3 align-items-start">
                                                    <div className="col-md-4 mb-3 mb-md-0">
                                                        <Form.Control
                                                            type="text"
                                                            value={newVideoName}
                                                            onChange={(e) => handleVideoNameChange(e.target.value)}
                                                            placeholder="Title"
                                                            className={`biolink-video-input ${videoNameError ? 'is-invalid' : ''}`}
                                                            maxLength={64}
                                                        />
                                                        <Form.Text className={newVideoName?.length > 64 ? 'text-danger' : 'text-muted'} style={{ fontSize: '12px' }}>
                                                            {newVideoName?.length}/64 characters
                                                        </Form.Text>
                                                        {videoNameError && (
                                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                                {videoNameError}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6 mb-3 mb-md-0">
                                                        <Form.Control
                                                            type="text"
                                                            value={newVideoUrl}
                                                            onChange={(e) => handleVideoUrlChange(e.target.value)}
                                                            placeholder="Enter Content URL"
                                                            className={`biolink-video-input ${videoUrlError ? 'is-invalid' : ''}`}
                                                        />
                                                        {videoUrlError && (
                                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                                {videoUrlError}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button
                                                            className="biolink-add-video-btn"
                                                            onClick={handleAddYouTubeVideo}
                                                            type="button"
                                                        >
                                                            <Plus size={18} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {youtubeVideos.length > 0 && (
                                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                                    <Droppable droppableId="youtube-videos">
                                                        {(provided) => (
                                                            <div
                                                                className="biolink-videos-list"
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                {youtubeVideos.filter(video => video.youtube_status !== 'deleted').map((video, index) => (
                                                                    <Draggable key={video.id} draggableId={String(video.id)} index={index}>
                                                                        {(provided) => (
                                                                            <div
                                                                                className="biolink-video-item"
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}
                                                                                style={{ ...provided.draggableProps.style }}
                                                                            >
                                                                                {editingVideoId === video.id ? (
                                                                                    <div className="biolink-edit-video-form p-2 w-100">
                                                                                        <div className="row g-2 align-items-start">
                                                                                            <div className="col-md-5">
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    value={editVideoName}
                                                                                                    onChange={(e) => handleEditVideoName(e.target.value)}
                                                                                                    placeholder="Content Name"
                                                                                                    className={`biolink-video-input ${editVideoNameError ? 'is-invalid' : ''}`}
                                                                                                    maxLength={64}
                                                                                                />
                                                                                                <Form.Text className={editVideoName?.length > 64 ? 'text-danger' : 'text-muted'} style={{ fontSize: '10px' }}>
                                                                                                    {editVideoName?.length}/64 characters
                                                                                                </Form.Text>
                                                                                                {editVideoNameError && (
                                                                                                    <div className="invalid-feedback" style={{ display: 'block', fontSize: '10px' }}>
                                                                                                        {editVideoNameError}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                            <div className="col-md-5">
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    value={video.url}
                                                                                                    className="biolink-video-input-disabled"
                                                                                                    readOnly
                                                                                                    disabled
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-md-2">
                                                                                                <div className="d-flex gap-2 mt-1">
                                                                                                    <button
                                                                                                        className="biolink-save-video-btn"
                                                                                                        onClick={handleSaveVideoEdit}
                                                                                                        type="button"
                                                                                                        title="Save"
                                                                                                    >
                                                                                                        <Check size={16} />
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="biolink-cancel-video-btn"
                                                                                                        onClick={handleCancelVideoEdit}
                                                                                                        type="button"
                                                                                                        title="Cancel"
                                                                                                    >
                                                                                                        <XIcon size={16} />
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="biolink-video-thumbnail-container">
                                                                                            {video.thumbnail ? (
                                                                                                <img
                                                                                                    src={video.thumbnail}
                                                                                                    alt="Video thumbnail"
                                                                                                    className="biolink-video-thumbnail"
                                                                                                    onError={(e) => {
                                                                                                        if (video.video_id) {
                                                                                                            e.target.src = `https://img.youtube.com/vi/${video.video_id}/hqdefault.jpg`
                                                                                                        } else {
                                                                                                            e.target.style.display = 'none'
                                                                                                            e.target.nextSibling.style.display = 'flex'
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            ) : null}
                                                                                            <div className="biolink-video-placeholder" style={{ display: video.thumbnail ? 'none' : 'flex' }}>
                                                                                                <div className="biolink-video-placeholder-icon">
                                                                                                    <img src={thumbImage} alt="" height={'30px'} style={{ borderRadius: '50%' }} />
                                                                                                </div>
                                                                                                <span>Content</span>
                                                                                            </div>
                                                                                            <div className="biolink-video-overlay">
                                                                                                <a
                                                                                                    href={video.url}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    className="biolink-video-play-btn"
                                                                                                    title="Watch video"
                                                                                                >
                                                                                                    <img src={thumbImage} alt="" height={'20px'} style={{ borderRadius: '50%' }} />
                                                                                                </a>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="biolink-video-info">
                                                                                            <span className="biolink-video-name" title={video.url_name || 'Video'}>
                                                                                                {video.url_name || 'Untitled Video'}
                                                                                            </span>
                                                                                            <span className="biolink-video-url" title={video.url} style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginTop: '4px' }}>
                                                                                                {video.url.length > 50 ? video.url.substring(0, 50) + '...' : video.url}
                                                                                            </span>
                                                                                            <button className='btn btn-sm btn-primary mt-1 biolink-total-click-btn' onClick={() => { localStorage.getItem('biolink_status') == 'paid' ? video_analysis(video) : subscription_fun() }}>TOTAL CLICK : {video?.total_clicks ? video?.total_clicks : '0'}</button>
                                                                                        </div>
                                                                                        <div className="biolink-video-actions">
                                                                                            <button
                                                                                                className={`biolink-toggle-video-btn ${!(video.is_hidden === true || video.is_hidden === 'true') ? 'active' : ''}`}
                                                                                                onClick={() => handleToggleVideoVisibility(video.id)}
                                                                                                type="button"
                                                                                                title={(video.is_hidden === true || video.is_hidden === 'true') ? 'Show video in preview' : 'Hide video from preview'}
                                                                                            >
                                                                                                {(video.is_hidden === true || video.is_hidden === 'true') ? <EyeOff size={16} color='red' /> : <Eye size={16} color='green' />}
                                                                                            </button>
                                                                                            <button
                                                                                                className="biolink-edit-link-btn"
                                                                                                onClick={() => handleEditVideo(video)}
                                                                                                type="button"
                                                                                                title="Edit Title"
                                                                                            >
                                                                                                <Edit2 size={16} />
                                                                                            </button>
                                                                                            <button
                                                                                                className="biolink-remove-video-btn"
                                                                                                onClick={() => handleRemoveVideo(video.id)}
                                                                                                type="button"
                                                                                                title="Delete Content"
                                                                                            >
                                                                                                <Trash2 size={16} />
                                                                                            </button>
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </Draggable>
                                                                ))}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                            )}
                                        </div>

                                        <div className="biolink-social-links-section">
                                            <h6 className="mb-3">Button</h6>

                                            <div className="biolink-add-link-form mb-5">
                                                <div className="row mb-4 align-items-start">
                                                    <div className="col-md-4 mb-3 mb-md-0">
                                                        <Form.Control
                                                            type="text"
                                                            value={newLinkName}
                                                            onChange={(e) => handleUrlNameChange(e.target.value)}
                                                            placeholder="Button Name"
                                                            className={`biolink-link-input ${newLinkNameError ? 'is-invalid' : ''}`}
                                                            maxLength={16}
                                                        />
                                                        <Form.Text className={newLinkName?.length > 16 ? 'text-danger' : 'text-muted'} style={{ fontSize: '10px' }}>
                                                            {newLinkName?.length}/16 characters
                                                        </Form.Text>
                                                        {newLinkNameError && (
                                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                                {newLinkNameError}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3 mb-md-0 position-relative">
                                                        <Form.Control
                                                            type="text"
                                                            value={newLinkUrl}
                                                            onChange={(e) => handleNewLinkUrlChange(e.target.value)}
                                                            placeholder="URL (e.g. https://www.xyz.com/user12)"
                                                            className={`biolink-link-input ${newLinkUrlError ? 'is-invalid' : ''}`}
                                                        />
                                                        {/* Changed from position-absolute to relative/block for better mobile layout */}
                                                        {/* <div className="form-text text-muted" style={{ fontSize: '12px', marginTop: '4px' }}>
                                                           
                                                        </div> */}
                                                        {newLinkUrlError && (
                                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '12px' }}>
                                                                {newLinkUrlError}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button
                                                            className="biolink-add-video-btn"
                                                            onClick={handleAddSocialLink}
                                                            type="button"
                                                        >
                                                            <Plus size={18} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {socialLinks.filter(link => link.social_status !== 'deleted').length > 0 && (
                                                <DragDropContext onDragEnd={handleOnSocialDragEnd}>
                                                    <Droppable droppableId="social-links">
                                                        {(provided) => (
                                                            <div
                                                                className="biolink-links-list"
                                                                {...provided.droppableProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                {socialLinks.filter(link => link.social_status !== 'deleted').map((link, index) => {
                                                                    const linkId = String(link.id || link._id)
                                                                    return (
                                                                        <Draggable key={linkId} draggableId={linkId} index={index}>
                                                                            {(provided) => (
                                                                                <div
                                                                                    className="biolink-link-item"
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    style={{ ...provided.draggableProps.style }}
                                                                                >
                                                                                    {editingLinkId === (link.id || link._id) ? (
                                                                                        <div className="biolink-edit-link-form pb-3 w-100">
                                                                                            <div className="row g-2">
                                                                                                <div className="col-md-5">
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        value={editLinkName}
                                                                                                        onChange={(e) => handleEditLinkName(e.target.value)}
                                                                                                        placeholder="Button Name"
                                                                                                        className={`biolink-link-input ${editLinkNameError ? 'is-invalid' : ''}`}
                                                                                                        maxLength={16}
                                                                                                    />
                                                                                                    <Form.Text className={editLinkName?.length > 16 ? 'text-danger' : 'text-muted'} style={{ fontSize: '10px' }}>
                                                                                                        {editLinkName?.length}/16 characters
                                                                                                    </Form.Text>
                                                                                                    {editLinkNameError && (
                                                                                                        <div className="invalid-feedback" style={{ display: 'block', fontSize: '10px' }}>
                                                                                                            {editLinkNameError}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>

                                                                                                <div className="col-md-5 position-relative">
                                                                                                    <Form.Control
                                                                                                        type="text"
                                                                                                        value={editLinkUrl}
                                                                                                        onChange={(e) => handleEditLinkUrlChange(e.target.value)}
                                                                                                        placeholder="URL"
                                                                                                        className="biolink-link-input-disabled"
                                                                                                        readOnly
                                                                                                        disabled
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="col-md-2">
                                                                                                    <div className="d-flex gap-2 mt-2">
                                                                                                        <button
                                                                                                            className="biolink-save-link-btn"
                                                                                                            onClick={handleSaveEdit}
                                                                                                            type="button"
                                                                                                            title="Save"
                                                                                                        >
                                                                                                            <Check size={16} />
                                                                                                        </button>
                                                                                                        <button
                                                                                                            className="biolink-cancel-link-btn"
                                                                                                            onClick={handleCancelEdit}
                                                                                                            type="button"
                                                                                                            title="Cancel"
                                                                                                        >
                                                                                                            <XIcon size={16} />
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <>
                                                                                            <div className="biolink-link-info mt-2">
                                                                                                <span className="biolink-link-name">{link.name}</span>
                                                                                                <span className="biolink-link-url">{link.url}</span>
                                                                                                <button
                                                                                                    className='btn btn-sm btn-primary mt-1 biolink-total-click-btn'
                                                                                                    onClick={() => { localStorage.getItem('biolink_status') == 'paid' ? button_analysis(link) : subscription_fun() }}
                                                                                                    type="button"
                                                                                                >
                                                                                                    TOTAL CLICK : {link?.total_clicks ? link.total_clicks : '0'}
                                                                                                </button>
                                                                                            </div>
                                                                                            <div className="biolink-link-actions">
                                                                                                <div className="biolink-link-action-row">
                                                                                                    <button
                                                                                                        className={`biolink-toggle-video-btn ${!(link.is_hidden === true || link.is_hidden === 'true') ? 'active' : ''}`}
                                                                                                        onClick={() => handleToggleSocialLinkVisibility(link.id || link._id)}
                                                                                                        type="button"
                                                                                                        title={(link.is_hidden === true || link.is_hidden === 'true') ? 'Show link in preview' : 'Hide link from preview'}
                                                                                                    >
                                                                                                        {(link.is_hidden === true || link.is_hidden === 'true') ? <EyeOff size={16} color='red' /> : <Eye size={16} color='green' />}
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="biolink-edit-link-btn"
                                                                                                        onClick={() => handleEditSocialLink(link)}
                                                                                                        type="button"
                                                                                                        title="Edit link"
                                                                                                    >
                                                                                                        <Edit2 size={16} />
                                                                                                    </button>
                                                                                                    <button
                                                                                                        className="biolink-remove-link-btn"
                                                                                                        onClick={() => handleRemoveSocialLink(link.id || link._id)}
                                                                                                        type="button"
                                                                                                        title="Remove link"
                                                                                                    >
                                                                                                        <Trash2 size={16} />
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    )
                                                                })}
                                                                {provided.placeholder}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className='text-center mt-5'>
                                    <button className='btn btn-primary' disabled={''} onClick={() => updatebiolinkFunction()} style={{ width: '100%' }}>{spinner ?
                                        <div className='d-flex justify-content-center'> <ButtonLoader /></div>
                                        :
                                        'UPDATE BIO PAGE'
                                    }</button>
                                </div>
                            </div>

                        </div>

                        {/* Right Section - Preview */}
                        <div className={`col-xl-5 ${mobileTab === 'editor' ? 'd-none d-xl-block' : ''}`}>
                            <div className='content'>
                                <BiolinkPreview
                                    bool={bool}
                                    setBool={setBool}
                                    backgroundType={backgroundType}
                                    selectedBackground={selectedBackground}
                                    selectedFontFamily={selectedFontFamily}
                                    selectedFontColor={selectedFontColor}
                                    profilePhoto={profilePhoto}
                                    profilePhoto2={profilePhoto2}
                                    showProfilePhoto={showProfilePhoto}
                                    title={title}
                                    showTitle={showTitle}
                                    paragraph={paragraph}
                                    showParagraph={showParagraph}
                                    bannerImage={bannerImage}
                                    bannerImage2={bannerImage2}
                                    showBanner={showBanner}
                                    socialLinks={socialLinks}
                                    youtubeVideos={youtubeVideos}
                                    isSelfDeleted={isSelfDeleted}
                                    userStatus={userStatus}
                                />
                            </div>
                        </div>
                    </div>

                }
            </div>
            <UpdateProfile show={show} setShow={setShow} />
            <BiolinkSubscription show2={show2} setShow2={setShow2} bool={bool} setBool={setBool} />
        </>
    )
}
